<template>
  <div class="product-list-item" :class="{ 'cart-mode': cartMode, 'is-catalog': isCatalog, [`sku--${product.sku}`]: 1 }">

    <h3 class="page-title text-center">{{ title }}</h3>
    <div :class="wrapperClasses">
      <div class="product" :class="extraClasses">
        <div class="ribbon" v-if="isSoldout">
          <div class="ribbon--name">Sold out</div>
        </div>
        <div class="ribbon" v-if="isComingSoon">
          <div class="ribbon--name -coming-soon">Coming Soon</div>
        </div>
        <!-- show products / frontpage ? -->
        <div class="product__block product__image" v-if="!cartMode" v-show="showPageSelector">
          <page-selector :product="product" v-model="choices.page" ref="selector" @pages="getPageSuccess" />
        </div>

        <!-- show shoping cart -->
        <div class="product-cart__info" v-if="cartMode">
          <div class="product-cart__image">
            <img class="img-responsive" :src="firstImage.preview" />
          </div>
          <div class="product-cart__title">
            {{ product.name }}
            <span class="product-catalog-name" v-if="product.catalogSku">( {{ catalogName(product) }} )</span>
            <product-choice-summary :product="product" :choices="choices" :quantity="quantity" v-if="isStockProductType" />
          </div>
          <div class="product-cart__value">
            {{ product.price | comma }} ฿
            <div class="product-cart__shipping" v-if="shippingFee">+ {{ shippingFee }} ฿</div>
          </div>
        </div>

        <!-- show product detail -->
        <!-- <div class="product__block product__block--form mt-15"> -->
        <div class="product__block--form">

          <!-- show products / frontpage ? -->
          <!--<div class="product__wrapper" v-if="!cartMode">
            <div class="product__title" v-if="titleAsLink">
              <router-link :to="{ name: 'product_detail', params: { sku: product.sku }}"
                           @click="$utils.fbTrack('clickProductListTitle', 1, { sku: product.sku })"
                           class="-title">{{ product.name }}</router-link>
            </div>

            <div class="product__title" v-if="!titleAsLink">
              {{ product.name }}
            </div>
            <span class="product__desc">{{ product.subtitle }}</span>
            <div class="text-muted -count-down mt-15" v-if="showCountdownTimer">สั่งซื้อได้ใน: {{ timeBeforeAvailable | period }}</div>
          </div>-->
          <div class="block-border radius block shadow">
          <div v-if="isCatalog || forceNoActions">
            <div class="product__action -view-details">
              <!-- <router-link :to="{ name: 'product_detail', params: { sku: product.sku }}" class="btn btn--purple">View details</router-link> -->
              <router-link :to="{ name: 'product_detail', params: { sku: product.sku }}" class="btn btn--purple">View details</router-link>
            </div>
          </div>

            <div v-else>
              <product-choice
                  ref="attributes"
                  :product="product"
                  :initialChoices="choices"
                  v-show="isStockProductType && showAttributes"
                  v-on:attrChanged="attrChanged" />

              <product-donate-choice
                  ref="donateChoice"
                  v-if="isDonateProductType && showAttributes"
                  :product="product"
                  :choices="donateConfig.choices"
                  :minimum="20"
                  :defaults="donateConfig.default"
                  :custom="donateConfig.customAmount"
                  :classes="donateChoiceClasses"
                  @change="amountChanged" />

              <product-donate-type :product="product" v-model="donateType" v-if="$route.query.type !== 'monthly'" />

              <div v-if="isStockProductType && showAttributes && $utils.isProductAvailable(this.product)" class="mt-30" :class="{ '-error': !stockAvailable }">
                จำนวนรายการคงเหลือ:
                <em v-if="!stockChecking"><span v-if="stockQuantity > 0">ประมาณ </span>{{ stockQuantity | comma }} รายการ</em>
                <em v-else>กำลังตรวจสอบ...</em>
                <div class="fl-right" v-if="stockAvailable">✔</div>
                <div class="fl-right" v-else>✗</div>
                <br><button class="text-muted-ss" @click="checkStock()" :disabled="stockChecking">ตรวจสอบอีกครั้ง</button>
              </div>

              <donor-info v-model="choices.info" />

              <product-cart-action
                  :stockAvailable="stockAvailable"
                  :attributes="choices"
                  v-show="!cartMode"
                  :product="product"
                  :initialQuantity="initialQuantity"
                  @resetQuantity="resetQuantity"
                  :addToCartButton="false"
                  :buyNowButton="false"
                  :style="{margin:0}"
                  ref="cartAction" />

              <div class="donate__wrapper" v-if="showPageSelector">
                <div class="text-center">
                  <button type="button" class="btn btn--purple" @click.prevent="donate">บริจาค</button>
                </div>
              </div>

              <div class="text-center mt-15 mb-15" v-else>
                <button type="button" class="btn btn--purple btn-md" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCartForm from './ProductCartForm.vue'
import ProductCartAction from './ProductCartAction.vue'
import ProductChoice from './ProductChoice.vue'
import ProductChoiceSummary from './ProductChoiceSummary.vue'
import ProductDonateChoice from './ProductDonateChoice.vue'
import ProductDonateType from './ProductDonateType.vue'
import PageSelector from './PageSelector.vue'
import DonorInfo from './DonorInfo.vue'

export default {
  components: {
    DonorInfo,
    ProductChoiceSummary,
    ProductCartAction,
    ProductCartForm,
    ProductChoice,
    ProductDonateChoice,
    ProductDonateType,
    PageSelector
  },
  name: 'ProductListItem',
  props: {
    product: {
      type: Object,
      required: true
    },
    initialQuantity: {
      type: Number,
      required: true
    },
    cartMode: {
      type: Boolean,
      required: false
    },
    showAttributes: {
      type: Boolean,
      required: false
    },
    useCarousel: {
      type: Boolean,
      required: false,
      default: false
    },
    titleAsLink: {
      type: Boolean,
      required: false,
      default: true
    },
    extraClasses: {
      type: String,
      required: false,
      default: ''
    },
    showTimeBeforeAvailable: {
      type: Boolean,
      required: false,
      default: false
    },
    forceNoActions: {
      type: Boolean,
      required: false,
      default: false
    },
    initialChoices: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      quantity: this.initialQuantity,
      timeBeforeAvailable: 0,
      stockAvailable: false,
      stockChecking: false,
      stockQuantity: 0,
      choices: this.initialChoices || {},
      showPageSelector: false,
      donateChoiceClasses: '',
      wrapperClasses: '',
      showDonateType: false,
      donateType: 'onetime',
      title: 'บริจาคเพื่อให้การศึกษาที่มีคุณภาพ',
      donateData: {
        onetime: {
          choices: [],
          customAmount: null,
          default: 0
        },
        monthly: {
          choices: [],
          customAmount: null,
          default: 0
        }
      }
    }
  },
  created () {
    this.stockAvailable = false
    if (this.isStockProductType) {
      if (this.product.stockAttributes && !this.initialChoices) {
        for (let item of this.product.stockAttributes) {
          this.choices[item.key] = item.attributes[0]
        }
      }
    }

    let t = setInterval(() => {
      this.timeBeforeAvailable = this.$utils.timeBeforeProductAvailable(this.product)
      if (this.timeBeforeAvailable <= 0) {
        clearInterval(t)
        if (this.isStockProductType) {
          this.checkStock()
        }
      }
    }, 1000)

    this.product.originalPrice = this.product.price

    this.$utils.setBodyClasses('product-page')

    this.initDonateType()

    if (this.$route.query.type === 'monthly') {
      this.title = 'การบริจาครายเดือนจะช่วยให้น้องๆ ที่ขาดโอกาสสามารถเข้าถึงการศึกษาได้มากขึ้น'
    }

    this.initDonateData()
  },
  computed: {
    firstImage () {
      return this.images[0]
    },
    images () {
      return this.$utils.processProductImages(this.product)
    },
    shippingFee () {
      if (this.product.shippingGroup) {
        return 0
      }
      return this.$utils.shippingFee(this.product, this.quantity)
    },
    isSoldout () {
      return (this.product.flags & 1) || (this.product.notAfter && this.product.notAfter < (new Date()).getTime())
    },
    isComingSoon () {
      return (this.product.flags & 2)
    },
    isCatalog () {
      return this.product.type === this.$const.PRODUCT_TYPES.CATALOG
    },
    showCountdownTimer () {
      return this.showTimeBeforeAvailable && (this.timeBeforeAvailable && this.timeBeforeAvailable >= 0)
    },
    isStockProductType () {
      return this.product.type === this.$const.PRODUCT_TYPES.STOCK
    },
    isDonateProductType () {
      return this.product.type === this.$const.PRODUCT_TYPES.DONATE
    },
    donateConfig () {
      return this.donateData[this.$store.state.donateType] || {}
    }
  },
  methods: {
    getPageSuccess (pages) {
      if (pages.length > 1) {
        this.showPageSelector = true
        this.donateChoiceClasses = ''
        this.wrapperClasses = ''
      } else {
        this.donateChoiceClasses = 'col-4'
        this.wrapperClasses = 'col-md-push-2 col-md-10 col-lg-push-2 col-md-8'
      }
    },
    initDonateType () {
      if (this.product.subscriptionAllowed) { // TODO Get flag from product subscription plan.
        if (this.$route.query.type === 'monthly') {
          this.donateType = this.$route.query.type
          this.$store.dispatch('setDonateType', this.donateType)
        } else {
          this.showDonateType = true
        }
      }
    },
    initDonateData () {
      if (this.product.meta.donation_amount_onetime) {
        this.donateData.onetime.choices = this.product.meta.donation_amount_onetime.split(',')
      }
      if (this.product.meta.donation_amount_default_onetime) {
        this.donateData.onetime.default = parseInt(this.product.meta.donation_amount_default_onetime)
      }
      if (this.product.meta.donation_custom_amount_onetime) {
        this.donateData.onetime.customAmount = true
      }

      if (this.product.meta.donation_amount_monthly) {
        this.donateData.monthly.choices = this.product.meta.donation_amount_monthly.split(',')
      } else {
        this.donateData.monthly.choices = this.donateData.onetime.choices
      }
      if (this.product.meta.donation_amount_default_monthly) {
        this.donateData.monthly.default = parseInt(this.product.meta.donation_amount_default_monthly)
      } else if (this.donateData.onetime.default) {
        this.donateData.monthly.default = this.donateData.onetime.default
      }
      if (this.product.meta.donation_custom_amount_monthly) {
        this.donateData.monthly.customAmount = true
      }
    },
    donate () {
      if (!this.$refs.donateChoice.validate()) {
        return
      }

      if (this.showPageSelector && this.$refs.selector) {
        if (!this.$refs.selector.validate()) {
          return
        }
      }

      this.$store.dispatch('clearCart').then(() => {
        this.$refs.cartAction.buyNow()
      })
    },
    catalogName (product) {
      const catalog = this.$store.state.products[product.catalogSku]
      return (catalog && catalog.name) || ''
    },
    updateValue (product, attributes, value) {
      const parsedValue = parseInt(value || 0)
      this.quantity = parsedValue
      this.$refs.cartAction.setQuantity(parsedValue)
      this.$emit('quantityChanged', product, attributes, parsedValue)

      this.stockAvailable = this.quantity <= this.stockQuantity
    },
    checkStock (showModal) {
      this.stockChecking = true
      if (showModal) {
        this.$modal.show({
          title: 'กรุณารอสักครู่',
          text: 'กำลังตรวจสอบรายการ ...',
          okButton: false
        })
      }

      let configSku = this.$utils.getProductConfigSku(this.product, this.choices)
      this.$http.get(`inventories/check/${configSku}`)
        .then(resp => {
          setTimeout(() => {
            this.stockChecking = false
            this.$modal.hide()
          }, 500)
          if (resp.body.item) {
            this.stockQuantity = resp.body.item.quantity || 0
          } else {
            this.stockQuantity = 0
          }
          this.stockAvailable = this.quantity <= this.stockQuantity
        })
        .catch(err => {
          console.log(err)
          setTimeout(() => {
            this.stockChecking = false
            this.$modal.hide()
          }, 500)
          this.stockAvailable = false
        })
    },
    resetQuantity () {
      this.quantity = 1
      if (this.$refs.cartForm) {
        this.$refs.cartForm.resetQuantity()
      }
      this.$emit('quantityChanged', this.product, 1)
    },
    itemRemoved (product, attributes, quantity) {
      this.$emit('itemRemoved', product, attributes, quantity)
    },
    attrChanged (choices) {
      this.choices = Object.assign({}, choices)
      setTimeout(() => {
        this.checkStock()
      }, 100)
    },

    amountChanged (amount) {
      this.updateDonationAmount(amount)
    },
    updateDonationAmount (amount) {
      this.product.price = parseInt(amount)
    }
  }
}
</script>

<style scoped lang="scss">
  .text-muted.-count-down {
    color: red;
  }
  .donate__wrapper {
    margin: 20px 0 0;

    button {
      width: 100%;
    }
  }
  .page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
</style>

<style>
  .VueCarousel-inner {
    align-items: center;
    min-height: 300px;
  }
  .VueCarousel-slide { text-align: center !important;}
  .VueCarousel-dot {
    padding: 2px 4px !important;
  }
  .VueCarousel-dot-inner {
    background: #fff !important;
    border: 1px solid #9D77BA !important;
  }
  .VueCarousel-dot--active .VueCarousel-dot-inner {
    background: #9D77BA !important;
  }
</style>



// WEBPACK FOOTER //
// ProductListItem.vue?3f086b3a